import React from 'react'
import "./testimonals.css"

const Testimonals = () => {
  return (
    <div>
        <section class="about-us">
    <div class="container">
      <h2 className='heading-style'>Testimonals</h2>
      <p className='review'>The Lonestar Stain and Seal tackled my fence and it looks amazing. I appreciate the time and knowledge they took to explain the product and process of staining the fence. Very friendly and a charismatic group of guys. Their communication was on point also. I highly recommend!</p>
      <p className='author'>- Manny M</p>
      <p className='review'>We had complex requirements for building the backyard, which involved laying down concrete as well as building gazebo Rahul was very thorough and very professional He not only kept us informed in each and every step, but made sure the end result was perfect. I Would definitely involve Lone star any future project</p>
      <p className='author'>- Pritam Panda</p>
      <p className='review'>Excellent service!  Highly recommend to all my neighbors and fence owners throughout Collin County.</p>
      <p className='author'>- Dennis Ogan</p>
      {/* <img  src={ aboutimg } alt="Company Team"/> */}
    </div>
    </section>
    </div>
  )
}

export default Testimonals
